// The partition every page and section of a site lives in.
//
// WHY IT IS COMPOSITE, AND NOT JUST `siteId`
//
// `siteId` is a slug the caller picks, so it is unique within an organization
// and NOWHERE ELSE — two tenants will both call a site "www", and most will.
// Hashing pages on the bare slug would put both organizations' pages in one
// partition: every list, every search and every get would read across the
// tenant boundary, and the more ordinary the name the worse it would be.
//
// So the hash carries the organization. The archived project reached the same
// shape by the same route — its key was `site-page/${domain}/${site}` — and the
// separator is a slash for the same reason: `/Name/Required` forbids it, so no
// slug can forge a key belonging to another organization.
//
// It is built HERE and nowhere else. Two call sites spelling it differently is
// a tenancy bug that looks like a missing row.
export const siteKeyOf = (orgId, siteId) => `${orgId}/${siteId}`;

// The stored column. Rows carry `orgId` and `siteId` beside it — redundant, and
// deliberately so: a row that cannot say which organization it belongs to
// without being parsed is one a backfill, a reindex or a person reading the
// table has to decode.
export const siteKey = {
  type: "string",
};
